var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjStoreHoverIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/folder-cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9838 16.4135C11.2255 16.5385 11.2255 19.0885 12.9838 19.2135H17.1588C17.6671 19.2135 18.1505 19.0302 18.5255 18.6885C19.7588 17.6135 19.1005 15.4468 17.4755 15.2468C16.8921 11.7302 11.8005 13.0635 13.0088 16.4135",
    fill: "#0C0507"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9838 16.4135C11.2255 16.5385 11.2255 19.0885 12.9838 19.2135H17.1588C17.6671 19.2135 18.1505 19.0302 18.5255 18.6885C19.7588 17.6135 19.1005 15.4468 17.4755 15.2468C16.8921 11.7302 11.8005 13.0635 13.0088 16.4135",
    fill: "#BFDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3337 9.2224V12.7807C18.3337 13.0474 17.9087 13.1641 17.7253 12.9724C17.3337 12.5641 16.842 12.2557 16.2753 12.0807C14.967 11.6724 13.4587 12.0724 12.5087 13.0557C11.9087 13.6974 11.5837 14.4974 11.567 15.3641C11.567 15.5141 11.492 15.6474 11.3753 15.7391C10.7753 16.2141 10.4087 16.9557 10.4087 17.8057V17.8141C10.4087 18.0807 10.217 18.3224 9.95033 18.3224H6.11699C3.66699 18.3307 1.66699 16.3307 1.66699 13.8724V5.3474C1.66699 3.31406 3.31699 1.66406 5.35033 1.66406H7.28366C8.64199 1.66406 9.06699 2.10573 9.60866 2.83073L10.7753 4.38073C11.0337 4.7224 11.067 4.76406 11.5503 4.76406H13.8753C15.8587 4.76406 17.542 6.06406 18.117 7.86406C18.242 8.23906 18.3087 8.6224 18.3253 9.03073C18.3337 9.08906 18.3337 9.16406 18.3337 9.2224Z",
    fill: "#2894FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjStoreHoverIc);
export default __webpack_public_path__ + "static/media/obj-store-hover-ic.556e1620e9a26ceffdb67e3c86c336aa.svg";
export { ForwardRef as ReactComponent };